import type { CSSProperties } from 'react';
import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export interface ToggleFontWeightCSS extends CSSProperties {
  '--toggleFontWeight': string;
}

export const toggleItem = css`
  display: flex;

  padding-bottom: ${spacing.sm}px;
`;

export const toggleContainer = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: ${spacing.xs}px;
  cursor: pointer;
`;

export const toggleLabel = css`
  ${responsiveText.BODY.MD};
  font-weight: var(--toggleFontWeight);
  color: var(--neutral-black-base);
  margin: 0;
  pointer-events: none;
`;

export const toggleSwitch = css`
  position: relative;
  width: 44px;
  height: 28px;
  background-color: var(--neutral-white-base);
  border: 1px solid var(--neutral-black-40);
  border-radius: 16px;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing.sm}px 0;
`;

export const toggleSlider = css`
  position: absolute;
  top: 3px;
  left: 4px;
  width: ${spacing.lg}px;
  height: ${spacing.lg}px;
  background-color: var(--neutral-black-70);
  border-radius: 50%;
  opacity: 0.7;
  transition: transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const disabled = css`
  opacity: 0.3;
  cursor: not-allowed;

  &:hover {
    background-color: transparent;
  }
`;

export const secondaryLabel = css`
  display: block;
  text-align: left;
  ${responsiveText.BODY.SM};
  color: var(--neutral-black-40);
  font-weight: 400;
  pointer-events: none;
`;

export const hiddenInput = css`
  position: absolute;
  opacity: 0;
  pointer-events: none;
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
  border: 0;

  &:checked + div {
    background-color: var(--brand-purple-base);
    border-color: var(--brand-purple-base);
  }

  &:checked + div > span {
    transform: translateX(14px);
    background-color: var(--neutral-white-base);
    opacity: 1;

    svg {
      opacity: 1;
    }
  }

  &:disabled + div {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;
